// Navigation map of the application shell.
//
// Single source of truth shared by the sidebar rail, the off canvas drawer and
// the breadcrumb, so a route added to the router only has to be declared once
// here to appear consistently in the three places.

export interface EntreeNavigation {
  /** Stable key emitted by HzSidebar and compared with the active entry. */
  readonly key: string;
  /** French label displayed in the rail and used as the breadcrumb parent. */
  readonly label: string;
  /** Name of the route pushed when the entry is activated. */
  readonly route: string;
  /** Path of the entry, so the rail renders real links and not buttons. */
  readonly href: string;
}

/** The seven entries of the product shell, in the order of the design pack. */
export const ENTREES_NAVIGATION: readonly EntreeNavigation[] = [
  { key: 'tableau-de-bord', label: 'Tableau de bord', route: 'tableau-de-bord', href: '/' },
  { key: 'clients', label: 'Clients', route: 'clients', href: '/clients' },
  { key: 'simulateurs', label: 'Simulateurs', route: 'simulateur', href: '/simulateur' },
  { key: 'portefeuilles', label: 'Portefeuilles', route: 'portefeuilles', href: '/portefeuilles' },
  { key: 'documents', label: 'Documents', route: 'documents', href: '/documents' },
  { key: 'conformite', label: 'Conformité', route: 'conformite', href: '/conformite' },
  { key: 'parametres', label: 'Paramètres', route: 'parametres', href: '/parametres' },
];

/** Route name to navigation key. A detail route stays under its parent entry. */
const CLE_PAR_ROUTE: Readonly<Record<string, string>> = {
  'tableau-de-bord': 'tableau-de-bord',
  clients: 'clients',
  client: 'clients',
  simulateur: 'simulateurs',
  portefeuilles: 'portefeuilles',
  documents: 'documents',
  conformite: 'conformite',
  parametres: 'parametres',
};

/** Navigation key highlighted for a route name; falls back to the dashboard. */
export function cleDepuisRoute(nom: string): string {
  return CLE_PAR_ROUTE[nom] ?? 'tableau-de-bord';
}

/** Entry owning a navigation key, or undefined when the key is unknown. */
export function entreeParCle(cle: string): EntreeNavigation | undefined {
  return ENTREES_NAVIGATION.find((entree) => entree.key === cle);
}
